import { medicalsApi } from "../api/medicalsApi";
import { Reference } from "../types/reference";
import { createEncounterIdentifierParam } from "../utils/DataTransformationUtils";
import { FHIRURL } from "../utils/FHIRURL";

const findReviewOfSystems = async (
  encounterReference: Reference,
  patientReference: Reference,
) => {
  const ENTITY_TYPE = "questionnaire";
  const ROS_QUESTIONNAIRE_CODE = "10187-3";

  const questionnaire = await medicalsApi.findQuestionnaireResponse(
    ROS_QUESTIONNAIRE_CODE,
    {
      limit: 1,
      ...createEncounterIdentifierParam(encounterReference),
      subject: patientReference?.reference,
      "exclude-status": ["entered-in-error"],
    },
  );

  if (!Array.isArray(questionnaire) || questionnaire.length !== 1) {
    console.log("Review of systems questionnaire not found");
    return;
  }

  return questionnaire[0];
};

const findQuestionnaire = async () => {
  const ENTITY_TYPE = "questionnaire";
  const ROS_QUESTIONNAIRE_CODE = "10187-3";
  const questionnaire = await medicalsApi.findEntities(
    { code: ROS_QUESTIONNAIRE_CODE, status: "active" },
    ENTITY_TYPE,
  );

  if (!Array.isArray(questionnaire) || questionnaire.length !== 1) {
    console.log("Review of systems questionnaire not found");
    return;
  }

  return questionnaire[0];
};

const createDefault = (
  questionnaire: Record<string, unknown>,
  encounterReference: Reference,
  patientReference: Reference,
  authoredDate: Date,
  practitionerReference: Reference,
) => {
  return {
    ...questionnaire,
    questionnaire: new FHIRURL(`Questionnaire/${questionnaire.id}`, {
      version: questionnaire.version,
      code: questionnaire.code[0]?.code,
    }).url,

    status: "in-progress",
    encounter: encounterReference,
    subject: patientReference,
    authored: authoredDate || new Date(),
    author: practitionerReference,
    source: practitionerReference,
  };
};

export const ReviewOfSystemsManager = {
  findReviewOfSystems,
  findQuestionnaire,
  createDefault,
};
